import { createUseStyles } from "react-jss";
import {colors} from "../../../constants/colors";
import {breakpoints} from "../../../constants/breakpoints";

const styles = createUseStyles({
  container: {
    position: "relative",
    maxWidth: "100%",
    overflow: "hidden",
    marginBottom: "15px"
  },
  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: 16,
  },
  textBlock: {
    flex: 1,
  },
  title: {
    margin: "0 0 8px 0",
    color: colors.lightBlack,
    fontWeight: "700",
    fontSize: "18px",
    lineHeight: "28px",
  },
  subtitle: {
    color: colors.mediumGrey,
    fontWeight: "500",
    fontSize: "18px",
    margin: 0,
    lineHeight: "28px",
  },
  buttons: {
    display: "flex",
  },
  navButton: {
    background: colors.white,
    border: `1px solid ${colors.darkGrey}`,
    borderRadius: 8,
    width: "36px",
    height: "36px",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background 0.2s ease",
    "&:hover": {
      background: colors.grayBlue50,
    },
    "& svg": {
      width: "20px",
      height: "20px",
      "& path": {
        stroke: colors.inactiveGrey
      }
    }
  },
  navButtonLeft: {
    extend: "navButton",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderRight: `0.5px solid ${colors.darkGrey}`,
  },
  navButtonRight: {
    extend: "navButton",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeft: `0.5px solid ${colors.darkGrey}`,
  },
  carouselWrapper: {
    position: "relative",
  },
  scrollArea: {
    display: "flex",
    gap: 16,
    overflowX: "auto",
    scrollBehavior: "smooth",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  card: {
    background: colors.white,
    borderRadius: 16,
    boxShadow: "0 12px 16px -4px rgba(16, 24, 40, 0.08), 0 4px 6px -2px rgba(16, 24, 40, 0.03)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    maxWidth: "475px",
    border: "1px solid" + colors.lightGrey,
    flexShrink: 0,
    "& svg": {
      width: "24px",
      height: "24px",
      "& path": {
        stroke: props => props.colorPalette
      }
    }
  },

  cardHeader: {
    height: 16,
    backgroundColor: props => props.colorPalette
  },

  cardBody: {
    padding: "32px",
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },

  cardTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },

  cardMainIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "auto",
    "& svg": {
      width: "40px",
      height: "40px"
    }
  },

  cardTitle: {
    fontSize: "18px",
    fontWeight: 600,
    color: colors.grey,
  },

  cardList: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    gap: "16px",
    display: "grid"
  },
  dividerContainer: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  cardListItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
    margin: "6px 0",
    color: colors.mediumGrey,
    fontSize: "16px",
  },

  divider: {
    flex: 1,
    border: "none",
    borderTop: "1px solid" + colors.lightGrey,
  },

  statusSection: {
    marginTop: "4px",
  },

  statusTitle: {
    whiteSpace: "nowrap",
    margin: 0,
    padding: "0 8px",
    textAlign: "center",
    fontWeight: 500,
    fontSize: "14px",
    color: colors.inactiveGrey,
    "& svg": {
      width: "20px",
      height: "20px",
      "& path": {
        stroke: colors.inactiveGrey + "!important"
      }
    }
  },

  cardFooter: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
  },

  price: {
    fontSize: "36px",
    fontWeight: 600,
    color: colors.lightBlack,
  },
  more: {
    display: "block",
    textAlign: "center",
    fontWeight: 400,
    fontSize: "16px",
    color: colors.paleGrey,
    marginTop: "16px"
  },
  explorePackage: {
    textDecoration: "none",
    color: colors.primary700Blue,
    fontWeight: "600",
    padding: "10px 18px",
    fontSize: "16px",
    backgroundColor: colors.primary50Blue,
    borderRadius: "8px",
    width: "100%",
    display: "flex",
    justifyContent: "center"
  },
});

export default styles;
